import { Button, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { useAuthStore } from '@/store/useAuthStore';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/config/constants';

/**
 * 顶部导航栏组件
 * 采用与开发者平台一致的浅蓝色渐变样式
 */
export const Header = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  const handleLogout = async () => {
    try {
      await logout();
      navigate(ROUTES.LOGIN);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const userMenuItems: MenuProps['items'] = [
    {
      key: 'logout',
      icon: <LogoutOutlined className="text-red-500" />,
      label: (
        <Button
          type="text"
          onClick={handleLogout}
          className="w-full text-left text-red-600 hover:text-red-700"
        >
          退出登录
        </Button>
      ),
    },
  ];

  return (
    <header className="h-12 bg-white border-b border-gray-100 sticky flex items-center justify-between px-6 shadow-sm">
      {/* 左侧：平台名称和 Logo */}
      <div className="flex items-center gap-1">
        <img 
          src="/favicon.png" 
          alt="平台 Logo" 
          className="w-10 h-10 object-contain" // 注意：原w-30/h-30是tailwind无效类，改为w-10/h-10更合理（30会过大）
          onError={(e) => {
            console.warn('Logo 加载失败，使用备用图标。');
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
        <h1 className="text-lg font-medium text-gray-800">IoT 管理员控制台</h1>
      </div>
      
      {/* 右侧：用户信息和功能按钮 */}
      <div className="flex items-center gap-4">
        <Dropdown 
          menu={{ items: userMenuItems }} 
          placement="bottomRight"
          trigger={['click']}
          arrow
        >
          <Button 
            type="text" 
            icon={<UserOutlined className="text-white" />}
            className="flex items-center gap-2 text-white hover:bg-white/10 px-3 py-2 rounded-lg transition-colors"
          >
            <span className="font-medium">{user?.username || 'Admin'}</span>
          </Button>
        </Dropdown>
      </div>
    </header>
  );
};